import { ToggleButton, ToggleButtonProps, Switch, SwitchProps } from "@mui/material";
import { styled } from "@mui/system";
import {getNeonColor} from "../theme";

const NeonToggleButton = styled(ToggleButton)<{ glowColor?: string }>(({ theme, glowColor }) => {
    const neonColor = glowColor || getNeonColor(theme);
    
    return {
        color: neonColor, // Default text color
        transition: "all 0.3s ease-in-out",
        fontWeight: "bold",
        display: "flex",
        flexDirection: "row", // Ensure horizontal layout
        alignItems: "center", // Center vertically
        justifyContent: "center", // Center horizontally
        textTransform: "none",
        minHeight: "50px", // Consistent height
        padding: "0px 16px", // Adjust padding to reduce excess spacing
        gap: "8px", // Space between icon and text
        border: `1px solid rgba(255, 255, 255, 0.3)`, // Add border
        borderRadius: "4px", // Add border radius
        position: "relative", // Needed for pseudo-elements
        overflow: "hidden", // Prevent glow overflow
        // Ensure borders are visible when adjacent to other buttons
        "&:not(:last-child)": {
            borderRight: "1px solid rgba(255, 255, 255, 0.3)",
        },
        "&:not(:first-child)": {
            borderLeft: "1px solid rgba(255, 255, 255, 0.3)",
        },
        "&::after": {
            content: "''",
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "4px", // Neon band height
            backgroundColor: neonColor,
            boxShadow: `0px 0px 3px ${neonColor}, 0px 0px 6px ${neonColor}`,
            transition: "opacity 0.3s ease-in-out",
            opacity: 0,
        },
        "&.Mui-selected": {
            color: "#fff",
            backgroundColor: "transparent",
            borderColor: neonColor, // Border color when selected
            "&::after": {
                opacity: 1, // Show neon band when selected
            },
        },
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderColor: "rgba(255, 255, 255, 0.5)", // Border color on hover
            // boxShadow: "0px 0px 5px #fff, 0px 0px 10px #fff",
        },
    };
});

const NeonToggle = styled(Switch)<{ glowColor?: string }>(({ theme, glowColor }) => {
    const neonColor = glowColor || getNeonColor(theme);
    
    return {
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            margin: 1,
            padding: 0,
            transform: 'translateX(2px)',
            '&.Mui-checked': {
                color: '#fff',
                transform: 'translateX(16px)',
                '& + .MuiSwitch-track': {
                    backgroundColor: neonColor,
                    opacity: 1,
                    border: 0,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: '#fff',
                    boxShadow: `0px 0px 8px ${neonColor}, 0px 0px 12px ${neonColor}`,
                },
            },
        },
        '& .MuiSwitch-thumb': {
            backgroundColor: '#ccc',
            width: 22,
            height: 22,
            transition: 'all 0.3s ease-in-out',
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            opacity: 1,
            transition: 'all 0.3s ease-in-out',
        },
        '&:hover .MuiSwitch-track': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
        },
        '&:hover .MuiSwitch-thumb': {
            boxShadow: `0px 0px 4px rgba(255, 255, 255, 0.5)`,
        },
    };
});

export { NeonToggleButton, NeonToggle };
